export const servicesData = [
  {
    slug: 'website-design',
    menuLabel: 'Website Design',
    title: 'Website Design Services',
    shortTitle: 'Website Design',
    heroImageSrc: '/websiteDesing.jfif',
    heroImageAlt: 'Vedanskrix website design service visual',
    summary:
      'We design websites that perform, engage, and convert while creating a strong first impression for your business.',
    homeDescription:
      'Modern, responsive website design aligned with your brand identity, user journey, and conversion goals.',
    heroTitle: 'Designing Websites That Build Trust, Engage Users, and Drive Growth',
    heroDescription:
      'Your website is more than just an online presence. It is the digital face of your business and often the first impression your audience experiences.',
    detailParagraphs: [
      'At Vedanskrix, we design websites that are not only visually appealing but also strategically built to perform. Every design decision we make is focused on one goal: helping your business grow.',
      'We combine modern UI/UX principles with business-driven strategy to create websites that are clean, responsive, and easy to navigate. Our designs are crafted to guide users smoothly through your content, ensuring they take meaningful actions such as making inquiries, booking services, or completing purchases. A well-designed website should not confuse users. It should convert them.',
      'Our team ensures that your website works flawlessly across all devices, including desktops, tablets, and smartphones. Speed, performance, and usability are at the core of our process. We pay attention to every detail, from layout structure and typography to color psychology and user flow, to create a seamless experience.',
      'We do not believe in generic templates. Every website we build is customized according to your brand identity, target audience, and business objectives. Whether you are a startup, a growing business, or an established company, we design solutions that scale with your needs.',
      'At Vedanskrix, we do not just design websites. We build powerful digital platforms that create impact, build trust, and deliver real results.'
    ],
    seoTitle: 'Website Design Company in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix offers website design services in Ahmedabad with responsive layouts, conversion-focused structure, and brand-led design for growing businesses.',
    seoKeywords: [
      'website design company in Ahmedabad',
      'website designer in Ahmedabad',
      'responsive website design Ahmedabad',
      'business website design Gujarat',
      'custom website design services'
    ],
    deliverables: [
      'Custom website design and layout planning',
      'Responsive design for desktop, tablet, and mobile',
      'Brand-focused visual styling and UI direction',
      'Clear UX flow and conversion-focused sections',
      'Performance-minded page structure',
      'Scalable website design built for future growth'
    ],
    outcomes: [
      'Stronger first impression for your brand',
      'Better engagement through cleaner user journeys',
      'Higher conversion potential from strategic layout decisions'
    ],
    ctaLabel: 'Discuss Website Design'
  },
  {
    slug: 'web-development',
    menuLabel: 'Web Development',
    title: 'Web Development Services',
    shortTitle: 'Web Development',
    heroImageSrc: '/web-development.jfif',
    heroImageAlt: 'Vedanskrix web development service visual',
    summary:
      'We build scalable, efficient, and secure web platforms that support business growth and long-term performance.',
    homeDescription:
      'Frontend and backend development for websites, platforms, dashboards, and custom web applications.',
    heroTitle: 'Building Powerful Web Solutions That Scale With Your Business',
    heroDescription:
      'A strong digital presence is built on more than design. It requires a solid, scalable, and high-performing foundation.',
    detailParagraphs: [
      'At Vedanskrix, our web development services focus on creating robust digital systems that not only function seamlessly but also support long-term business growth.',
      'We specialize in both frontend and backend development, ensuring that every website or web application we build is fast, secure, and reliable. From dynamic business websites to complex platforms and admin dashboards, we develop solutions that are tailored to your specific requirements.',
      'Our development approach is structured and performance-driven. We focus on clean coding standards, optimized loading speeds, and smooth functionality across all devices and browsers. Every system we build is designed to handle real-world usage, whether it is managing data, processing user interactions, or supporting high traffic.',
      'Security and scalability are at the core of our development process. We ensure that your platform is protected against vulnerabilities while also being flexible enough to grow as your business expands. Our goal is to build systems that do not just work today, but continue to perform in the future.',
      'We do not rely on shortcuts or generic builds. Every project is developed with precision, keeping your business logic, user needs, and future goals in mind.',
      'At Vedanskrix, we do not just develop websites. We engineer digital platforms that are reliable, scalable, and built for success.'
    ],
    seoTitle: 'Web Development Company in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix provides web development services in Ahmedabad including custom business websites, scalable web apps, and responsive front-end development.',
    seoKeywords: [
      'web development company in Ahmedabad',
      'custom website development Ahmedabad',
      'business website development Gujarat',
      'frontend backend development Ahmedabad',
      'web application development company'
    ],
    deliverables: [
      'Frontend and backend web development',
      'Business websites and custom web applications',
      'Admin panels and service platform development',
      'Architecture planning and scalable code structure',
      'Testing, deployment, and ongoing technical support',
      'Performance and security-focused implementation'
    ],
    outcomes: [
      'More reliable digital systems for daily operations',
      'Stronger technical foundation for future expansion',
      'Smoother connection between design and functionality'
    ],
    ctaLabel: 'Start Web Development'
  },
  {
    slug: 'mobile-app-development',
    menuLabel: 'Mobile App Development',
    title: 'Mobile App Development Services',
    shortTitle: 'Mobile Apps',
    summary:
      'We create mobile apps that combine smooth performance, intuitive UX, and scalable architecture for growing businesses.',
    homeDescription:
      'Android, iOS, and cross-platform app development focused on usability, speed, and business value.',
    heroTitle: 'Mobile app development for businesses that need seamless performance and better user experiences.',
    heroDescription:
      'Vedanskrix builds mobile applications for Android, iOS, and cross-platform ecosystems with a clear focus on usability, security, and long-term scalability.',
    detailParagraphs: [
      'We develop mobile applications that are designed to deliver seamless performance and exceptional user experiences. In a mobile-first world, a reliable and engaging app can improve customer interaction, strengthen loyalty, and increase operational efficiency.',
      'Our team builds applications for Android, iOS, and cross-platform environments so your product can reach users across devices without compromising experience. We focus on intuitive design, fast performance, and smooth functionality throughout the app journey.',
      'From idea validation to final deployment, we follow a structured process that includes planning, UI and UX design, development, testing, and support. Each app is tailored around specific business needs so it creates value for both users and stakeholders.',
      'We also prioritize scalability, making sure your app can evolve as your business expands. Security and data protection are considered at every stage to keep the final product safe, dependable, and ready for real-world use.',
      'Our goal is simple: to create mobile applications that are functional, impactful, and future-ready, not just technically complete.'
    ],
    seoTitle: 'Mobile App Development Company in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix offers mobile app development in Ahmedabad for Android, iOS, and cross-platform apps with strong UI, practical features, and business-focused delivery.',
    seoKeywords: [
      'mobile app development company in Ahmedabad',
      'android app development Ahmedabad',
      'ios app development Ahmedabad',
      'cross platform app development Gujarat',
      'business app developers Ahmedabad'
    ],
    deliverables: [
      'Android, iOS, and cross-platform app development',
      'App planning, UX flow, and interface design',
      'Feature-based development tailored to business goals',
      'Testing, launch readiness, and deployment support',
      'Scalable app structure for future growth',
      'Security-focused implementation and support'
    ],
    outcomes: [
      'Stronger mobile engagement with users',
      'Better digital convenience for customers and teams',
      'Scalable app experiences prepared for growth'
    ],
    ctaLabel: 'Build A Mobile App'
  },
  {
    slug: 'iot-solutions',
    menuLabel: 'IoT Solutions',
    title: 'IoT Solutions Services',
    shortTitle: 'IoT Solutions',
    summary:
      'We build connected IoT ecosystems that automate processes, collect real-time data, and support smarter decisions.',
    homeDescription:
      'Connected device solutions, monitoring systems, automation workflows, and real-time data visibility.',
    heroTitle: 'IoT solutions that connect devices, automate operations, and turn data into action.',
    heroDescription:
      'Vedanskrix creates IoT systems that link sensors, devices, and software into secure, scalable ecosystems built for smarter operations.',
    detailParagraphs: [
      'Our IoT solutions help businesses connect devices, automate processes, and gain valuable insights through real-time data. By bringing smart technology into everyday operations, we help organizations improve efficiency and reduce manual effort.',
      'We design IoT systems that connect sensors, devices, and software platforms into one unified ecosystem. This allows businesses to monitor activity in real time, automate workflows, and optimize operational performance more effectively.',
      'From smart automation to industrial monitoring systems, each solution is tailored to the real needs of the business. We focus on systems that are secure, scalable, and reliable enough to deliver long-term value.',
      'Data plays a central role in IoT, so we make sure the information collected is meaningful, actionable, and easy to understand. Our goal is to move businesses from reactive decisions toward more proactive and intelligent strategies.',
      'At Vedanskrix, we do not just implement connected technology. We create intelligent systems that improve how businesses operate every day.'
    ],
    seoTitle: 'IoT Solutions Company in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix provides IoT solutions in Ahmedabad including connected device workflows, dashboard interfaces, monitoring systems, and business automation support.',
    seoKeywords: [
      'IoT solutions company in Ahmedabad',
      'Internet of Things services Ahmedabad',
      'IoT dashboard development Gujarat',
      'smart device integration Ahmedabad',
      'business automation IoT solutions'
    ],
    deliverables: [
      'Connected device ecosystem planning',
      'Sensor, device, and platform integration',
      'Real-time monitoring and automation workflows',
      'Dashboard and data visibility interfaces',
      'Secure and scalable IoT architecture support',
      'Business-specific IoT use case implementation'
    ],
    outcomes: [
      'Improved operational visibility in real time',
      'Less manual effort through automation',
      'More informed decision-making using live data'
    ],
    ctaLabel: 'Talk About IoT'
  },
  {
    slug: 'ethical-hacking',
    menuLabel: 'Ethical Hacking',
    title: 'Ethical Hacking & Cyber Security Services',
    shortTitle: 'Ethical Hacking',
    summary:
      'We identify vulnerabilities early through ethical hacking, security assessment, and practical recommendations for safer systems.',
    homeDescription:
      'Proactive cyber security testing, vulnerability assessment, and security improvement guidance for safer digital operations.',
    heroTitle: 'Ethical hacking services that help secure systems before threats become real problems.',
    heroDescription:
      'Vedanskrix performs proactive security assessments and ethical testing to identify risks early and strengthen the digital resilience of your business.',
    detailParagraphs: [
      'Cybersecurity is no longer optional. It is essential. Our ethical hacking services are designed to protect your business by identifying vulnerabilities before they can be exploited by real attackers.',
      'We conduct detailed security assessments that include vulnerability analysis and penetration testing to evaluate the strength of your systems, applications, and networks. This proactive approach helps you detect risks early and respond before they become business issues.',
      'Our team follows strict ethical practices and industry standards, ensuring confidentiality, professionalism, and responsible reporting throughout the process. We provide clear findings and actionable recommendations instead of vague technical noise.',
      'Beyond testing, we also help businesses think long term about security by improving awareness, identifying weak points, and supporting more mature cyber strategies over time.',
      'Our goal is to help you build trust with your users and stakeholders by making sure your systems are secure, resilient, and better prepared for evolving digital threats.'
    ],
    seoTitle: 'Ethical Hacking Services in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix offers ethical hacking services in Ahmedabad with cyber security positioning, vulnerability review support, and website security-focused consulting.',
    seoKeywords: [
      'ethical hacking services in Ahmedabad',
      'cyber security company Ahmedabad',
      'website security services Gujarat',
      'vulnerability assessment Ahmedabad',
      'penetration testing company Ahmedabad'
    ],
    deliverables: [
      'Vulnerability assessment and penetration testing',
      'Security review for systems, apps, and networks',
      'Risk identification and reporting',
      'Actionable security recommendations',
      'Security posture improvement guidance',
      'Confidential and standards-based assessment process'
    ],
    outcomes: [
      'Earlier detection of security weaknesses',
      'Greater trust in your digital systems',
      'Stronger long-term cyber security readiness'
    ],
    ctaLabel: 'Request Security Consultation'
  },
  {
    slug: 'ui-ux-branding',
    menuLabel: 'UI/UX & Branding',
    title: 'UI/UX Design & Branding Services',
    shortTitle: 'UI/UX & Branding',
    summary:
      'We shape digital experiences through intuitive UI, thoughtful UX, and brand systems that feel clear and consistent.',
    homeDescription:
      'Interface design, user experience planning, and branding strategy that improve usability and strengthen brand perception.',
    heroTitle: 'UI/UX and branding services that make digital experiences clearer, stronger, and more memorable.',
    heroDescription:
      'Vedanskrix combines user-focused interface design with consistent brand direction so websites, apps, and digital products feel easier to use and easier to trust.',
    detailParagraphs: [
      'We create meaningful digital experiences through thoughtful UI and UX design backed by strong branding strategy. Design is not only about how something looks. It is about how people interact with it and how your brand is remembered.',
      'Our UI and UX process focuses on understanding user behavior, simplifying navigation, and creating intuitive interfaces that feel natural to use. Every interaction is designed to reduce friction and improve usability.',
      'Alongside interface design, we help businesses build stronger brand identity across digital touchpoints. From color systems and typography to visual consistency and layout decisions, we make sure the brand communicates clearly and professionally.',
      'Whether it is a website, mobile app, or digital product, we maintain consistent design language so the user experience feels seamless from one screen to the next.',
      'At Vedanskrix, we design experiences that connect, engage, and leave a lasting impact while also supporting engagement and conversion goals.'
    ],
    seoTitle: 'UI UX Design Services in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix offers UI UX design services in Ahmedabad with interface design, user flow planning, and branding-led digital experiences.',
    seoKeywords: [
      'UI UX design services in Ahmedabad',
      'branding agency Ahmedabad',
      'website UI design Ahmedabad',
      'user experience design Gujarat',
      'digital branding services Ahmedabad'
    ],
    deliverables: [
      'User interface design for websites and apps',
      'UX planning focused on smoother user journeys',
      'Brand identity direction across digital platforms',
      'Color, typography, and visual system definition',
      'Usability-focused design refinement',
      'Consistent digital experience across touchpoints'
    ],
    outcomes: [
      'Cleaner and more intuitive user experiences',
      'Stronger brand consistency across digital channels',
      'Higher engagement through thoughtful interaction design'
    ],
    ctaLabel: 'Plan UI/UX Work'
  },
  {
    slug: 'admission-guidance',
    menuLabel: 'Admission Guidance',
    title: 'Admission Guidance Services',
    shortTitle: 'Admission Guidance',
    heroImageSrc: '/admission-guidance.png',
    heroImageAlt: 'Vedanskrix admission guidance service visual',
    summary:
      'We help students and parents navigate admissions with clearer course selection, application guidance, and process support.',
    homeDescription:
      'Admission guidance for college selection, application planning, documentation, and next-step decision support.',
    heroTitle: 'Admission guidance that brings clarity to course selection, college choices, and application decisions.',
    heroDescription:
      'Vedanskrix supports students and families with structured admission guidance so important education decisions feel more informed, organized, and confident.',
    detailParagraphs: [
      'Our admission guidance services are designed to help students and parents make better decisions during one of the most important stages of academic planning. Choosing the right course, college, or career direction can feel overwhelming without the right support.',
      'At Vedanskrix, we provide structured guidance for college admissions, course selection, application planning, and documentation preparation. We help students understand their options more clearly so they can move forward with greater confidence.',
      'Our approach is personalized and practical. We take time to understand academic background, interests, long-term goals, and available opportunities before suggesting the right path. This helps avoid confusion and improves decision quality.',
      'We also support students through timelines, application steps, and process-related questions so they do not miss important requirements. The aim is to reduce stress while keeping the admission journey more organized and manageable.',
      'At Vedanskrix, we do not just offer information. We provide meaningful admission guidance that helps students take the next academic step with clarity and direction.'
    ],
    seoTitle: 'Admission Guidance Services in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix offers admission guidance services in Ahmedabad for course selection, college applications, documentation support, and student decision planning.',
    seoKeywords: [
      'admission guidance services in Ahmedabad',
      'college admission consultant Ahmedabad',
      'student admission support Gujarat',
      'course selection guidance Ahmedabad',
      'college application help Ahmedabad'
    ],
    deliverables: [
      'Course and college selection guidance',
      'Admission planning and process support',
      'Documentation and application checklist help',
      'Guidance aligned to student goals and background',
      'Timeline clarity for key admission steps',
      'Structured support for informed academic decisions'
    ],
    outcomes: [
      'More clarity during admission decision-making',
      'Better preparation for college applications',
      'Reduced confusion for students and parents'
    ],
    ctaLabel: 'Get Admission Guidance'
  },
  {
    slug: 'visa-services',
    menuLabel: 'Visa Services',
    title: 'Visa Guidance Services',
    shortTitle: 'Visa Services',
    summary:
      'We provide structured visa guidance, documentation support, and interview preparation for smoother international opportunities.',
    homeDescription:
      'Personalized visa consultancy with documentation clarity, process support, and interview readiness.',
    heroTitle: 'Visa guidance services that make complex international processes clearer and more manageable.',
    heroDescription:
      'Vedanskrix supports study and work abroad journeys through accurate documentation guidance, process clarity, and practical preparation at every step.',
    detailParagraphs: [
      'We provide comprehensive visa consultancy services for individuals aiming to study or work abroad. The visa process can feel complicated and time-consuming, so our role is to bring clarity, structure, and confidence throughout the journey.',
      'Our support includes documentation guidance, application assistance, and interview preparation to improve readiness and reduce uncertainty. We work closely with each client to understand their goals and provide guidance that matches their situation.',
      'We keep the process transparent, accurate, and aligned with current requirements. Our team stays updated on changing regulations so the advice you receive remains relevant and dependable.',
      'From initial consultation to final approval stages, we support you through the complete process. The focus is on making the journey smoother, less stressful, and more efficient.',
      'At Vedanskrix, we help turn global aspirations into reality through expert guidance, structured communication, and dedicated support.'
    ],
    seoTitle: 'Visa Consultant in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix provides visa guidance in Ahmedabad for documentation support, process clarity, and interview preparation across multiple visa categories.',
    seoKeywords: [
      'visa consultant in Ahmedabad',
      'visa guidance services Ahmedabad',
      'student visa consultant Ahmedabad',
      'work visa support Ahmedabad',
      'visa documentation assistance Gujarat'
    ],
    deliverables: [
      'Documentation guidance and checklist support',
      'Application process assistance',
      'Interview preparation and confidence building',
      'Personalized guidance based on goals',
      'Current requirement and regulation alignment',
      'End-to-end support through the visa journey'
    ],
    outcomes: [
      'Less confusion during the visa process',
      'Better preparation before critical submissions',
      'More confidence through guided support'
    ],
    ctaLabel: 'Ask For Visa Guidance'
  },
  {
    slug: 'job-placement',
    menuLabel: 'Job Placement',
    title: 'Job Placement & Career Support Services',
    shortTitle: 'Job Placement',
    summary:
      'We help candidates build stronger careers through profile improvement, interview support, and practical placement guidance.',
    homeDescription:
      'Career support services including resumes, interviews, profile positioning, and job readiness training.',
    heroTitle: 'Job placement and career support that prepares candidates for stronger long-term opportunities.',
    heroDescription:
      'Vedanskrix helps candidates improve readiness for the real job market through resume development, profile strengthening, and interview-focused support.',
    detailParagraphs: [
      'Our job placement services are designed to help individuals build stronger and more successful careers. We prepare candidates for real-world opportunities through practical training, personalized support, and career-focused guidance.',
      'Our process includes resume development, profile optimization, interview preparation, and career counseling. We work with each candidate to identify strengths, close presentation gaps, and align efforts with suitable opportunities.',
      'We understand that every individual has different goals, so our support is tailored accordingly. The objective is not only to help someone get a job, but to help build a career path that feels meaningful and sustainable.',
      'We also work to bridge the gap between education and industry by focusing on the skills employers actually value. This includes building confidence, communication, and professional readiness.',
      'At Vedanskrix, we believe the right guidance can change lives, and we stay committed to helping candidates move forward with more clarity and confidence.'
    ],
    seoTitle: 'Job Placement Services in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix offers job placement services in Ahmedabad with resume support, interview preparation, profile positioning, and career guidance.',
    seoKeywords: [
      'job placement services in Ahmedabad',
      'career consultancy Ahmedabad',
      'resume support Ahmedabad',
      'interview preparation Ahmedabad',
      'placement consultancy Gujarat'
    ],
    deliverables: [
      'Resume development and profile optimization',
      'Interview preparation and career counseling',
      'Guidance aligned to personal goals and strengths',
      'Job readiness and communication improvement',
      'Industry-focused preparation support',
      'Long-term career positioning guidance'
    ],
    outcomes: [
      'Stronger professional presentation for candidates',
      'Better readiness for interviews and hiring steps',
      'Improved confidence during career growth decisions'
    ],
    ctaLabel: 'Get Career Support'
  },
  {
    slug: 'seo-services',
    menuLabel: 'SEO Services',
    title: 'SEO Services',
    shortTitle: 'SEO Services',
    summary:
      'We improve search visibility through content structure, keyword strategy, on-page SEO, and sustainable optimization.',
    homeDescription:
      'SEO services focused on discoverability, targeted traffic, local visibility, and long-term search growth.',
    heroTitle: 'SEO services that help your website get discovered, attract better traffic, and grow steadily.',
    heroDescription:
      'Vedanskrix builds strong SEO foundations through on-page structure, keyword planning, local optimization, and continuous improvement for sustainable results.',
    detailParagraphs: [
      'Our SEO services are designed to improve your website visibility, attract targeted traffic, and support long-term growth. In a competitive digital space, simply having a website is not enough. It also needs to be discoverable.',
      'We focus on building a strong SEO foundation through keyword research, on-page optimization, and clean content structure. Each strategy is aligned with your business goals and the audience you want to reach.',
      'We also apply location-based SEO techniques so businesses can reach local customers more effectively. From technical improvements to content refinement, we work to strengthen overall search performance.',
      'Our approach is data-driven, which allows us to track performance, identify improvements, and refine strategy over time. We focus on sustainable growth rather than short-term shortcuts.',
      'At Vedanskrix, we help businesses build a stronger online presence that leads to consistent and meaningful search visibility.'
    ],
    seoTitle: 'SEO Company in Ahmedabad | Vedanskrix',
    seoDescription:
      'Vedanskrix provides SEO services in Ahmedabad with on-page SEO, service-page optimization, keyword planning, and search-ready website structure.',
    seoKeywords: [
      'SEO company in Ahmedabad',
      'on page SEO services Ahmedabad',
      'local SEO company Gujarat',
      'SEO content optimization Ahmedabad',
      'search engine optimization services'
    ],
    deliverables: [
      'Keyword research and SEO planning',
      'On-page optimization and content structure improvement',
      'Location-based and local SEO support',
      'Technical SEO and search-readiness checks',
      'Performance monitoring and improvement guidance',
      'Sustainable SEO strategy for long-term growth'
    ],
    outcomes: [
      'Improved website visibility on search engines',
      'More targeted traffic from relevant searches',
      'Stronger long-term digital growth foundation'
    ],
    ctaLabel: 'Improve SEO Setup'
  }
];

export const featuredServiceSlugs = [
  'website-design',
  'mobile-app-development',
  'ethical-hacking',
  'iot-solutions',
  'admission-guidance',
  'visa-services',
  'job-placement'
];

export const sliderSlides = [
  {
    eyebrow: 'Website Design + SEO',
    title: 'Build a stronger digital first impression with Vedanskrix.',
    description:
      'Creative website design, strong on-page structure, and clean brand presentation that helps your business look more trusted online.',
    ctaLabel: 'Explore Services',
    ctaTo: '/services',
    imageSrc: '/silder1.jfif',
    imageAlt: 'Vedanskrix slider visual one'
  },
  {
    eyebrow: 'Tech Services',
    title: 'Web development, mobile apps, IoT, and cyber-focused execution.',
    description:
      'From business websites to app flows and connected systems, Vedanskrix supports practical digital builds with a growth mindset.',
    ctaLabel: 'View Tech Services',
    ctaTo: '/services/website-design',
    imageSrc: '/slider2.jfif',
    imageAlt: 'Vedanskrix slider visual two'
  },
  {
    eyebrow: 'Growth Support',
    title: 'Visa guidance and career support under one clear brand experience.',
    description:
      'We also support students and professionals through guidance-led services that feel more structured, confident, and easy to understand.',
    ctaLabel: 'Open Visa Services',
    ctaTo: '/services/visa-services',
    imageSrc: '/silder3.jfif',
    imageAlt: 'Vedanskrix slider visual three'
  },
  {
    eyebrow: 'Brand Presence',
    title: 'Professional visuals and polished presentation for modern businesses.',
    description:
      'Vedanskrix helps brands present services more clearly with stronger design direction, cleaner messaging, and a confident digital image.',
    ctaLabel: 'See About Vedanskrix',
    ctaTo: '/about',
    imageSrc: '/silder4.jfif',
    imageAlt: 'Vedanskrix slider visual four'
  },
  {
    eyebrow: 'Career + Guidance',
    title: 'Support that connects opportunity, planning, and practical next steps.',
    description:
      'From career-focused support to process guidance, our service mix is structured to help clients move ahead with better clarity.',
    ctaLabel: 'Contact Vedanskrix',
    ctaTo: '/contact',
    imageSrc: '/silder5.jfif',
    imageAlt: 'Vedanskrix slider visual five'
  }
];

export const findServiceBySlug = (slug) => servicesData.find((service) => service.slug === slug);
